// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCkkXDkJfxP3lP_GFUju1aDJntRIl4huQQ",
  authDomain: "project123-bdeb4.firebaseapp.com",
  projectId: "project123-bdeb4",
  storageBucket: "project123-bdeb4.appspot.com",
  messagingSenderId: "150962961953",
  appId: "1:150962961953:web:b2aa6d2e0046ca9dcead60",
  measurementId: "G-T69X15YFCR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db ,storage};